import { useQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'

import Response from './Response'
import { RequestsInfo } from './RequestsInfo'
import OrderStateWithInfo from './OrderStateWithInfo'

export function RequestTile({
  order
}: {
  order: GraphQL.OrderFragmentFragment
}) {
  const { data, loading } = useQuery(AdminAPI.stay.GET, {
    variables: { id: order.stayId, withSpace: true }
  })

  const stay = getFragment(SharedAPI.stay.STAY_FRAGMENT, data?.getStay)
  const space = getFragment(SharedAPI.space.SPACE_FRAGMENT, stay?.space)

  return (
    <article className="flex flex-row items-start gap-5 rounded bg-white p-5">
      <div className="flex flex-row">
        {loading && (
          <h4 className="h-6 w-10 animate-pulse rounded-small bg-text-light">
            {space?.identifier}
          </h4>
        )}
        {!loading && (
          <h4 className="text-heading2 font-normal text-text-light">
            {space?.identifier}
          </h4>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-2">
        <RequestsInfo order={order} />
      </div>
      {order.state === GraphQL.OrderState.Pending && <Response order={order} />}
      {order.state !== GraphQL.OrderState.Pending && (
        <OrderStateWithInfo order={order} />
      )}
    </article>
  )
}
